import React, { useState } from "react";
import { useSelector } from "react-redux";

import styles from "./AutoBetsStopLossOrWin.module.css";
import clickAudio from "../../audios/click.mp3";
import useSound from "use-sound";
import getSoundEffectVolume from "../../utils/getSoundEffectVolume";

const AutoBetsStopLossOrWin = ({ onChange, value, isChangeable, isOnWin }) => {
  const [tempValue, setTempValue] = useState(value);
  const sounds = useSelector((state) => state.sounds);
  const user = useSelector((state) => state.user);
  const [playClickSound] = useSound(clickAudio, {
    volume: getSoundEffectVolume(),
    soundEnabled: !sounds.isSoundEffectsMute,
  });
  const clickSound = () => {
    playClickSound();
  };

  const handleBlur = () => {
    if (isChangeable) {
      const val = parseInt(tempValue);
      if (val > 0 && (isOnWin ? true : val <= user.balance)) {
        onChange(val);
        if (isOnWin) {
          localStorage.setItem("onWinStopValue", val);
        } else {
          localStorage.setItem("onLossStopValue", val);
        }
      } else {
        onChange(0);
      }
    }
  };
  return (
    <div className={styles.controlGroup}>
      <label className={styles.inputLabel}>
        {isOnWin ? "Stop on Profit" : "Stop on Loss"}
      </label>
      <span className={styles.betContainer}>
        <span className={styles.betInputWrapper}>
          <input
            type="number"
            style={{ position: "relative" }}
            className={`${styles.inputField} ${
              isChangeable ? styles.ableToClick : styles.disableToClick
            }`}
            value={tempValue}
            step="any"
            min={0.0}
            max={isOnWin ? undefined : user.balance}
            readonly={!isChangeable}
            onBlur={handleBlur}
            onChange={(e) => {
              if (isChangeable) {
                clickSound();
                setTempValue(e.target.value);
              }
            }}
          />
        </span>
      </span>
    </div>
  );
};

export default AutoBetsStopLossOrWin;
